export const investment = [
    {
        id: "1",
        name: "Economy Package",
        about: "This is a save-as-you-go-designed package that offers you the opportunity to start and grow whatever you have.",
        image: `${process.env.PUBLIC_URL}/assets/img/economy.svg`,
        style: {width: "80%"},
        features: [
            	"• Suited for individuals looking to boost their investment portfolio while also splitting their risk",
                "• Minimum amount of  N200,000",
                "• Minimum tenor of 3 months with the flexibility to determine how long and how much to save",
                "• Principal and accrued interest are  paid at the agreed date of maturity",
                "• Liquidation before maturity is discouraged as this package is to help build a saving/investment culture. In exceptional cases however, the investor will have to forfeit the full accrued interest."
        ],

    },
    {
        id: "2",
        name: "Fixed Plan",
        about: "Simple and straightforward, the fixed plan involves you starting with a specified amount for a fixed duration after which the principal and accrued interest are paid to you as a lump sum.",
        image: `${process.env.PUBLIC_URL}/assets/img/fixed.svg`,
        style: {width: "100%"},
        features: [
                "• Minimum investment amount of N1,000,000 which may be topped up (minimum top up amount of 500,000)  at any time without restriction",
                "• Suitable for  investors looking to invest one-off in return for a bulk payment at maturity",
                "• Minimum tenor of 3 months and a maximum of 1-year",
                "• Interest rate is fixed over the period and the accumulated amount can be rolled over at maturity",
                "• Investment could be liquidated before maturity, subject to pre-liquidation fee charged on interest only."
        ],

    },
    {
        id: "3",
        name: "Extra Income Plan",
        about: "Looking to make extra money monthly? Then this plan is the best fit for you as it serves as a source of steady income for you. With this plan, interest is paid to you on a monthly basis",
        image: `${process.env.PUBLIC_URL}/assets/img/extra.svg`,
        style: {width: "70%"},
        features: [
            	"• Suited for investors who are interested in making periodic income on their investments",
                "• Minimum investment amount of N1,000,000 with no maximum limit",
                "• Minimum tenor of  6 months and a maximum of 1-year",
                "• Interest rate is fixed and the investment amount can be rolled over upon maturity",
                "• No liquidation before maturity"
        ],

    },
   /* {
        id: "4",
        name: "The Upfront Payment Plan",
        about: "Make quick money for reinvestment or business, get your interest paid to you upfront at the start of your investment with our upfront payment plan. ",
        image: `${process.env.PUBLIC_URL}/assets/img/upfront.svg`,
        features: [
                "• Product provides instant returns on investments to meet immediate needs",
                "• Minimum investment amount of N1,000,000 with no maximum limit",
                "• Minimum tenor of 6 months and a maximum of 1 year",
                "• Principal amount could be paid at maturity or rolled over for another term",
                "• No liquidation before maturity"
        ],

    },
    {
        id: "5",
        name: "Prime Package",
        about: "For individuals or organisations looking to lock large sums for a fixed tenor.",
        image: `${process.env.PUBLIC_URL}/assets/img/prime2.svg`,
        features: [
            "• Suitable for institutions/private companies",
            "• Minimum investment amount of  N50,000,000 with no maximum limit",
            "• Minimum tenor of 1 year",
            "• Interest can be paid monthly, quarterly or at maturity"
            
            
        ],

    }*/
]
